<template>
    <div>
        <v-text-field v-model="model.firstName" :rules="rules" label="Fornavn"></v-text-field>
    </div>
    <div>
        <v-text-field v-model="model.lastName" :rules="rules" label="Etternavn"></v-text-field>
    </div>
    <div>
        <v-text-field v-model="email" :rules="requiredEmailRules" label="E-post"></v-text-field>
    </div>
    <div>
        <v-text-field v-model="workEmail" :rules="emailRules" label="Jobb e-post"></v-text-field>
    </div>
    <phone-input v-model="model.phone" :phone-codes="phoneCountryCodes" />
</template>

<script lang="ts" setup>
import { Profile } from './profilesModels';
import PhoneInput from '../shared/components/PhoneInput.vue';
import { useVModel } from '@vueuse/core';
import { emailFormat, isRequired } from '../shared/formValidationRules';
import { PhoneCountryCode } from '../shared/models';
import { computed } from 'vue';

interface Props {
    profile: Profile;
    phoneCountryCodes: Array<PhoneCountryCode>;
}

type Emits = {
    (e: 'update:profile', value: Profile): void;
};

const emit = defineEmits<Emits>();
const props = defineProps<Props>();

const email = computed({
    get: () => props.profile.email,
    set: (value: string) => {
        emit('update:profile', { ...props.profile, email: value });
    }
});

const workEmail = computed({
    get: () => props.profile.workEmail,
    set: (value: string) => {
        emit('update:profile', { ...props.profile, workEmail: value ? value : undefined });
    }
});

const rules = [isRequired];
const requiredEmailRules = [...rules, emailFormat];
const emailRules = [emailFormat];

const model = useVModel(props, 'profile', emit);
</script>
